import { Icon } from "web/components"

export default function ResizeHandle({ onResizeHandleMouseDown }) {
  return (
    <div className="resize-handle relative -top-7 flex justify-end text-neutral-6">
      <div
        className="cursor-se-resize pb-2 pr-2"
        draggable="true"
        onMouseDown={onResizeHandleMouseDown}
      >
        <Icon name="arrows-pointing-out" />
      </div>
    </div>
  )
}
